import * as React from "react";

type Theme = "light";

interface ThemeContextValue {
  theme: Theme;
  resolvedTheme: "light";
  setTheme: (theme: Theme) => void;
}

const ThemeContext = React.createContext<ThemeContextValue | undefined>(
  undefined
);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  // Always use light theme
  React.useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark");
    root.classList.add("light");
  }, []);

  const value: ThemeContextValue = {
    theme: "light",
    resolvedTheme: "light",
    setTheme: () => {
      // No-op: theme is always light
    },
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeContext() {
  const context = React.useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
}

export { ThemeContext };
export type { Theme, ThemeContextValue };
